import i18n from 'modules/core/lib/i18n'

export const fileFormatOptions = [
  {
    label: 'CSV',
    value: 'csv',
  },
  {
    label: 'Excel',
    value: 'xlsx',
  },
]
export const timeFormatOptions = () => {
  return [
    {
      label: i18n.t('project_management.selector_options.time_format_selector.decimals'),
      value: 'hours',
    },
    {
      label: i18n.t('project_management.selector_options.time_format_selector.minutes'),
      value: 'hours_minutes',
    },
  ]
}
export const exportTypeOptions = () => {
  return [
    {
      label: i18n.t('project_management.selector_options.export_type_selector.total_time'),
      value: 'total_time',
    },
    {
      label: i18n.t('project_management.selector_options.export_type_selector.total_time_by_date'),
      value: 'total_time_by_date',
    },
    {
      label: i18n.t(
        'project_management.selector_options.export_type_selector.total_time_and_cost_by_month'
      ),
      value: 'total_time_and_cost_by_month',
    },
    {
      label: i18n.t(
        'project_management.selector_options.export_type_selector.total_time_by_employee'
      ),
      value: 'total_time_by_employee',
    },
    {
      label: i18n.t('project_management.selector_options.export_type_selector.expenses'),
      value: 'expenses',
    },
    {
      label: i18n.t('project_management.selector_options.export_type_selector.shifts'),
      value: 'shifts',
    },
    {
      label: i18n.t('project_management.selector_options.export_type_selector.tasks'),
      value: 'tasks',
    },
    {
      label: i18n.t('project_management.selector_options.export_type_selector.subprojects'),
      value: 'subprojects',
    },
  ]
}
export const dateRangeOptions = () => {
  return [
    {
      label: i18n.t('project_management.selector_options.date_range_selector.current_month'),
      value: 'current_month',
    },
    {
      label: i18n.t('project_management.selector_options.date_range_selector.last_month'),
      value: 'last_month',
    },
    {
      label: i18n.t('project_management.selector_options.date_range_selector.last_90_days'),
      value: 'last_90_days',
    },
    {
      label: i18n.t('project_management.selector_options.date_range_selector.custom_range'),
      value: 'custom_range',
    },
  ]
}
